import app from './application-container';
import { point_point_distance } from './vector3';
import { LOG, display_message_to_user } from '@phi/logging/frontend';

// TODO: add proper types and remove ts-ignores
/** This receives text identifiers that require some processing before the actual message is displayed. */
export function display_advanced_message_to_user(textId: 'rigidMoveManipulator' | 'rigidMoveManipulatorTangentMode' | 'vertexDist' | 'edgeSmoothness') {
    if (app.state.dragging_type != 'none')
        return;

    let messageText = '';
    const alert_level = LOG.INFO;
    switch (textId) {
        case 'rigidMoveManipulator':
            if (!app.state.is_mobile)
                messageText = 'Hit G or L to flip between Global and Local coordinate axes.';
            break;

        case 'rigidMoveManipulatorTangentMode':
            if (!app.state.is_mobile)
                messageText = 'After rotation, hit L to align manipulator with current edge tangent.';
            break;

        case 'vertexDist': {
            // Display distance between two selected vertices
            // @ts-ignore
            const v1 = uid_selected_vertices.getItemAtIndex(0);
            // @ts-ignore
            const v2 = uid_selected_vertices.getItemAtIndex(1);
            const dist = point_point_distance(
                // @ts-ignore
                get_display_vector_from_unitless_vector(v1.object3d.position),
                // @ts-ignore
                get_display_vector_from_unitless_vector(v2.object3d.position),
            );
            // @ts-ignore
            messageText = `Dist: ${dist.toFixed(App.settings.coordinate_decimals)} ${App.state.display_units}`;
            break;
        }

        case 'edgeSmoothness': {
            // @ts-ignore
            const eid = uid_selected_edges.getItemAtIndex(0).id;
            // @ts-ignore
            if (uil_can_make_edge_smooth(eid) && uil_can_make_edge_nonsmooth(eid)) {
                messageText = 'Edge is smooth on one end, non-smooth on the other';
            // @ts-ignore
            } else if (uil_can_make_edge_smooth(eid)) {
                messageText = 'Edge is not smooth';
            // @ts-ignore
            } else if (uil_can_make_edge_nonsmooth(eid)) {
                messageText = 'Edge is smooth';
            }
            break;
        }
    }

    if (messageText != '')
        display_message_to_user(alert_level, messageText);
}
